<script>
const API_KEY = "AIzaSyA65cF0KEbxFSJOUm0vBLngP00OiFky1QA";

export default {
  API_KEY,
};
</script>
;
